export const PptIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_198_3502)">
      <path
        d="M8.7876 15.2875C12.7876 15.2875 16.0376 12.0375 16.0376 8.03748H1.5376C1.5376 12.05 4.7876 15.2875 8.7876 15.2875Z"
        fill="#C8421D"
      />
      <path
        d="M8.7876 0.787476V8.03748H16.0376C16.0376 4.03748 12.8001 0.787476 8.7876 0.787476Z"
        fill="#FF8F6A"
      />
      <path
        d="M1.5498 8.03748H8.7998V0.787476C4.7998 0.787476 1.5498 4.03748 1.5498 8.03748Z"
        fill="#ED6B47"
      />
      <path
        d="M7.4123 12.0625H0.787305C0.349805 12.0625 -0.0126953 11.7 -0.0126953 11.2625V4.7375C-0.0126953 4.3 0.349805 3.9375 0.787305 3.9375H7.4123C7.8498 3.9375 8.2123 4.3 8.2123 4.7375V11.2625C8.2123 11.7 7.8498 12.0625 7.4123 12.0625Z"
        fill="#C8421D"
      />
      <path
        d="M3.5377 8.575V10.2875H2.5752V5.5625H4.4877C5.0377 5.5625 5.4752 5.7 5.7877 5.975C6.1002 6.25 6.2627 6.6125 6.2627 7.075C6.2627 7.525 6.1002 7.8875 5.7877 8.1625C5.4752 8.4375 5.0377 8.575 4.4877 8.575H3.5377ZM3.5377 7.85H4.4877C4.7502 7.85 4.9627 7.775 5.1002 7.6375C5.2377 7.4875 5.3127 7.3125 5.3127 7.0875C5.3127 6.8625 5.2502 6.675 5.1127 6.525C4.9752 6.375 4.7752 6.3 4.5002 6.3H3.5502V7.85H3.5377Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M8.1876 4.66248C8.1876 4.68748 8.1876 4.71248 8.1876 4.73748V11.2625C8.1876 11.7 7.8251 12.0625 7.3876 12.0625H2.7876L3.2626 12.775H8.0501C8.4876 12.775 8.8501 12.4125 8.8501 11.975V5.44998C8.8626 5.04998 8.5751 4.71248 8.1876 4.66248Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_198_3502">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
